import React from "react";
import { Button } from "semantic-ui-react";
import ContactNewModal from "contact/new/App";

interface Props {
  onContactCreated: (contactId: number) => void
}

const NewContact = (props: Props) => {
  const [displayNewContactModal, setDisplayNewContactModal] = React.useState(false);

  return <>
    <Button
      type="button"
      primary
      fluid
      onClick={() => setDisplayNewContactModal(true)}
      style={{ marginBottom: 2 }}
    >
      {RESX.Buttons.btnNew}
    </Button>
    <ContactNewModal
      isOpen={displayNewContactModal}
      onClose={() => setDisplayNewContactModal(false)}
      onCreated={c => {
        props.onContactCreated(c.contactId);
        setDisplayNewContactModal(false);
      }}
    />
  </>
};

export default NewContact;